import { render, staticRenderFns } from "./StockSettings.vue?vue&type=template&id=7d8ca762"
import script from "./StockSettings.vue?vue&type=script&lang=js"
export * from "./StockSettings.vue?vue&type=script&lang=js"
import style0 from "./StockSettings.vue?vue&type=style&index=0&id=7d8ca762&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports